export function authUser(state) {
  return state.user
}

export function authUserRoles(state) {
  if(state.user) {
    return state.user.roles[0].permissions.default
  }
}

export function isDistributor(state) {
  return state.user ? state.user.roles[0].name === 'rayner_distributor' : false
}

export function isAdmin(state) {
  if(state.user) {
    return state.user.roles[0].permissions.default.includes('admin_read_reports')
  }

  return false
}

export function isSurgeon(state) {
  return isUserInRole(state.user, 'surgeon')
}

export function isSurgeonPlus(state) {
  return (state.user && (state.user.is_trial || state.user.is_licensed))
}

export function isRayproPlusTrial(state) {
  return (state.user && state.user.is_trial)
}

export function isLicensed(state) {
  return (state.user && (state.user.is_trial || state.user.is_licensed))
}

export function isHospitalAdmin(state) {
  // TODO: This should be changed to check by ID
  return state.user ? state.user.roles[0].name === 'hospital_admin' : false
}

export function distributorCountries(state) {
  if(state.user) {
    return state.user.countries
  }
}

function isUserInRole(user, roleName) {
  if (user) {
    return user.roles.reduce((acc, curr) => {
      if (acc) return true
      return curr.name === roleName
    }, false)
  }
  else {
    return false
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/user/getters.js
// module id = null
// module chunks = 